
function makeStickyHeight() {
	var leftItemsHeight = jQuery("#leftPane").height();
	var rightItemsHeight = jQuery("#rightPane").height();

	var stickyWrapper = jQuery(".sticky-wrapper-polyfill:not(.fixed-height)");

	if ( !leftItemsHeight || !rightItemsHeight || !stickyWrapper ) {
		return;
	}

	if (stickyWrapper.length > 1){
		stickyCount = stickyWrapper.length;
		var stickyWrapperHeight = stickyWrapper.height() * stickyCount;
	} else {
		var stickyWrapperHeight = stickyWrapper.height();
	}

	/*
		Calculating height for sticky on depending layout
	*/
	if (stickyWrapper.parent().attr('id') === "leftPane" ) {
		var leftPaneMargin = jQuery('#leftPane').outerHeight(true) - jQuery('#leftPane').outerHeight();
		var leftPaneElementsHeight = leftItemsHeight - stickyWrapperHeight;
		var resultDifference = rightItemsHeight - leftPaneElementsHeight - leftPaneMargin;
		resultDifference = resultDifference < 600 ? 600 : resultDifference;
		stickyWrapper.css('height', resultDifference + 'px');
	}
	else {
		var rightPaneMargin = jQuery('#rightPane').outerHeight(true) - jQuery('#rightPane').outerHeight();
		var rightPaneElementsHeight = rightItemsHeight - stickyWrapperHeight;
		if (stickyWrapper.length > 1){
			var resultDifference = (leftItemsHeight - rightPaneElementsHeight - rightPaneMargin) / stickyCount;
		}
		else {
			var resultDifference = leftItemsHeight - rightPaneElementsHeight - rightPaneMargin;
		}
		resultDifference = resultDifference < 600 ? 600 : resultDifference;
		stickyWrapper.css('height', resultDifference + 'px');
	}


	jQuery(window).scroll();

}

jQuery(function() {
	makeStickyHeight();
});
